export const ENTITY_TYPE_LABEL = 'Potential Tenants';

export const NUMBER_OF_ENTITY_TYPE_LABEL = 'Business Locations';
